import { useLocalStorageState } from 'ahooks';
import { keyBy } from 'lodash';
import { useEffect, useMemo } from 'react';
import { FilterableField } from 'components/organisms/tasks/fields';
import { PastProjectStatusField } from '../fields';
import { GroupBy, isAllowedForGroupBy, NoneField } from './group-by';

const PROJECT_LIST_GROUP_BY_LOCALSTORAGE_KEY = 'project_list.v2.group_by';

export const useProjectListGroupByState = (
  fields: FilterableField[],
): [string, (value?: string) => void] => {
  const [group, setGroup] = useLocalStorageState<string>(
    PROJECT_LIST_GROUP_BY_LOCALSTORAGE_KEY,
    GroupBy.None,
  );

  const fieldsForGroupBy = useMemo((): FilterableField[] => {
    return [
      NoneField,
      ...[PastProjectStatusField, ...fields].filter(isAllowedForGroupBy),
    ];
  }, [fields]);
  const lookup = useMemo(
    () => keyBy(fieldsForGroupBy, 'fieldName'),
    [fieldsForGroupBy],
  );

  useEffect(() => {
    if (group === GroupBy.None) {
      return;
    }
    const isFieldAvailable = lookup[group];

    if (!isFieldAvailable) {
      setGroup(GroupBy.None);
    }
  }, [group, lookup, setGroup]);

  return [group, setGroup];
};
